import useSWR from 'swr';
import { useAuth } from '@teko/auth-react';
import { useTenantConfig, useServices } from 'contexts';
import { useDebounceValue } from './useDebounce';
import { DiscoveryKeyword } from '@teko/discovery';

const SUGGESTION_TYPE = {
  KEYWORD: 'SUGGESTION_TYPE_KEYWORD',
  PRODUCT: 'SUGGESTION_TYPE_PRODUCT',
};

export const useKeywords = (keyword: string, limit = 5) => {
  const { terminal } = useTenantConfig();
  const { discoveryService } = useServices();
  const debouncedKeyword = useDebounceValue(keyword, 300);
  const params = {
    terminalCode: terminal,
    q: debouncedKeyword?.trim(),
    limit,
  };
  const { data, error } = useSWR(
    terminal && !!debouncedKeyword?.trim()
      ? [`${discoveryService.getBaseUrl}/keywords`, JSON.stringify(params)]
      : null,
    async (_: string, paramsJson: string) => {
      return await discoveryService.getKeyword(JSON.parse(paramsJson));
    },
    {
      revalidateOnFocus: false,
    },
  );

  const suggestionsKeyword: DiscoveryKeyword[] = (
    data?.result?.keywords || []
  ).filter((el: DiscoveryKeyword) => el.type === SUGGESTION_TYPE.KEYWORD);

  const suggestionsProduct: DiscoveryKeyword[] = (
    data?.result?.keywords || []
  ).filter((el: DiscoveryKeyword) => el.type === SUGGESTION_TYPE.PRODUCT);

  return {
    result: suggestionsProduct?.length
      ? suggestionsProduct
      : suggestionsKeyword,
    isLoading: !error && !data,
    isError: error,
    isSuggestProduct: !!suggestionsProduct?.length,
  };
};

export const useRecommendedKeywords = (startCallApi: boolean) => {
  const { terminal } = useTenantConfig();
  const { discoveryService } = useServices();
  const { user } = useAuth();
  const phoneNumber = user?.telephone;
  const userId = user?.userId;
  const params = {
    terminalCode: terminal,
    userId,
    phoneNumber,
    limit: 10,
  };
  const { data, error } = useSWR(
    startCallApi && terminal
      ? [
          `${discoveryService.getBaseUrl}/recommended-search-terms`,
          JSON.stringify(params),
        ]
      : null,
    async (_: string, paramsJson: string) => {
      return await discoveryService.getPopularKeyword(JSON.parse(paramsJson));
    },
    {
      revalidateOnFocus: false,
    },
  );
  return {
    result: data?.result?.terms || [],
    isLoading: !error && !data,
    isError: error,
  };
};
